import React from 'react';
import { Skeleton } from 'primereact/skeleton';
import { cotizacionRowSkeletonCSS, skeletonListCSS } from './Skeletons.css';

const StepperPlaceholder = ({ steps = 5 }) => (
    <>
        {Array.from({ length: steps }).map((_, i) => (
            <React.Fragment key={i}>
                <Skeleton className="crs-step" shape="circle" size="1.15rem" />
                {i < steps - 1 && (
                    <Skeleton className="crs-step-seg" height="4px" borderRadius="2px" />
                )}
            </React.Fragment>
        ))}
    </>
);

const SingleRow = () => (
    <div css={cotizacionRowSkeletonCSS()}>
        {/* Mobile collapsed header */}
        <div className="crs-header">
            <div className="crs-info">
                <Skeleton width="65%" height="0.95rem" borderRadius="6px" />
                <Skeleton width="50%" height="0.72rem" borderRadius="6px" />
            </div>
            <div className="crs-car-col-mobile">
                <Skeleton width="90px" height="0.78rem" borderRadius="6px" />
                <Skeleton width="70px" height="0.9rem" borderRadius="6px" />
            </div>
            <div className="crs-chevron">
                <Skeleton shape="circle" size="0.95rem" />
            </div>
        </div>

        {/* Mobile stepper — funnel mock */}
        <div className="crs-mobile-stepper">
            <StepperPlaceholder steps={5} />
        </div>

        {/* Desktop grid */}
        <div className="crs-desktop-grid">
            {/* cr-info: name + meta */}
            <div className="crs-col crs-col-info">
                <Skeleton width="70%" height="0.95rem" borderRadius="6px" />
                <Skeleton width="55%" height="0.72rem" borderRadius="6px" />
            </div>

            {/* cr-car-col: unit + 2-3 stats */}
            <div className="crs-col crs-col-car">
                <Skeleton width="75%" height="0.78rem" borderRadius="6px" />
                <Skeleton width="85%" height="0.72rem" borderRadius="6px" />
                <Skeleton width="65%" height="0.72rem" borderRadius="6px" />
            </div>

            {/* cr-action: main + detail */}
            <div className="crs-col crs-col-action">
                <Skeleton width="80%" height="0.8rem" borderRadius="6px" />
                <Skeleton width="55%" height="0.7rem" borderRadius="6px" />
            </div>

            {/* cr-price: value + date pill (right aligned) */}
            <div className="crs-col crs-col-price">
                <Skeleton width="80px" height="0.9rem" borderRadius="6px" />
                <Skeleton width="68px" height="0.7rem" borderRadius="10px" />
            </div>

            {/* cr-stepper: 5 step circles connected by segments */}
            <div className="crs-stepper-col">
                <StepperPlaceholder steps={5} />
            </div>
        </div>
    </div>
);

const CotizacionRowSkeleton = ({ count = 5 }) => (
    <div css={skeletonListCSS()} aria-busy="true" aria-live="polite">
        {Array.from({ length: count }).map((_, i) => (
            <SingleRow key={i} />
        ))}
    </div>
);

export default CotizacionRowSkeleton;
